import { memo } from 'react';

interface InfoCardProps {
  title: string;
  description: string;
  className?: string;
}

const InfoCard: React.FC<InfoCardProps> = memo(
  ({ title, description, className = '' }) => (
    <div
      className={`tc-mv-blur flex flex-col items-start self-stretch p-4 px-6 rounded-2xl bg-gray-500! text-white mb-2 ${className}`}>
      <p className="sm:text-lg text-base font-semibold leading-[150%]">
        {title}
      </p>
      <p className="font-normal leading-[150%] text-sm sm:text-base">
        {description}
      </p>
    </div>
  ),
);

export { InfoCard };
